import React from 'react';
import { styled } from 'styled-components';
import Text from '@ingka/text';
import { useTranslation } from 'react-i18next';
import Progress from './Progress';
import colors from '../styles/colors';
import type { OperationPage } from '../types/app';

export interface AppHeaderProps {
  page: OperationPage;
  children?: React.ReactNode;
}

const StyledDivider = styled.div`
  margin-bottom: 2.5rem;
  border-top: 1px solid ${colors.neutral.grey200};
`;

const StyledHeader = styled(Text)`
  &&& {
    text-align: center;
    margin: 0.67em 0;
  }
`;

const getTranslationKey = (page?: OperationPage): string | undefined => {
  if (page) {
    return page === 'start'
      ? `pages.start.titleAriaLabel`
      : `pages.${page}.pageTitle`;
  }
};

const AppHeader: React.FC<AppHeaderProps> = ({ page, children }) => {
  const { t } = useTranslation();
  const ariaTranslationKey = getTranslationKey(page);
  const showProgress = page !== 'confirm';
  return (
    <>
      <StyledHeader
        tagName="h1"
        textStyle="Heading.M"
        aria-label={ariaTranslationKey && t(ariaTranslationKey)}
      >
        {t('components.appHeader.title')}
      </StyledHeader>
      {showProgress && <Progress page={page} />}
      {children}
      <StyledDivider />
    </>
  );
};

export default AppHeader;
